export const buildInvoiceUploadPayload = (file, fileBase64, values = {}) => {
  const fnolInfo = Object.fromEntries(
    ["inbox_type", "description", "diagnosis"]
      .map((key) => [key, values[key]?.trim()])
      .filter(([, value]) => value)
  );
  return {
    file_name: file.name,
    file_base64: fileBase64,
    ...(Object.keys(fnolInfo).length ? { fnol_info: fnolInfo } : {}),
  };
};
